<template>
  <div>
    <NavbarComponent/>
    <LangSwitcherComponent/>
    <router-view></router-view>
    <FooterComponent/>
  </div>
</template>

<script>
import NavbarComponent from './components/NavbarComponent'
import FooterComponent from './components/FooterComponent'
import LangSwitcherComponent from './components/LangSwitcherComponent'

export default {
  name: 'App',
  components: { LangSwitcherComponent, FooterComponent, NavbarComponent }
}
</script>

<style>
  .AppTitle {
    color: #ca420e;
  }

  html {
    color: #1f1f1f;
  }

  .uk-notification-message-success {
    background: #ca420e;
    color: #FFF;
    text-align: center;
  }

  .uk-notification-message-danger {
    background: #db2b17;
    color: #FFF;
    text-align: center;
  }
</style>
